import axios from 'axios'
import { ElMessage } from "element-plus";
import app from '@/main.js'
import commonFn from '@/tools/commonFn'
import { removeRoutes } from '@/router'
axios.defaults.params = {
	_t: Date.now()
};
axios.defaults.data = {
	_t: Date.now()
};
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API + '/api', // 所有的请求地址前缀部分
	timeout: 60000, // 请求超时时间毫秒
	// withCredentials: true, // 异步请求携带cookie
	headers: {},
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可以在这里添加请求头等信息
    const token = commonFn.getLocalStorage('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    // 请求错误处理
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
	(response) => {
		// 2xx 范围内的状态码都会触发该函数。
		// 对响应数据做点什
		if (response.data.message == '用户没有操作权限') {
			return {
				success: false,
				message: '用户没有操作权限',
				data: [],
			}
		} else {
			return response.data
		}
	},
	(error) => {
		// 超出 2xx 范围的状态码都会触发该函数。
		// 对响应错误做点什么
		if (error?.response?.status == 403) {
			if (!commonFn.getLocalStorage('login')) {  // 避免多次跳转
				commonFn.setLocalStorage('login', 1, 's1');
				setTimeout(() => {
					removeRoutes();
					app.config.globalProperties.$replace('/login', {
						fromPath: encodeURIComponent(app.config.globalProperties.$route.fullPath)
					});
				}, 500)
			}
			return {
				success: false,
				message: '请登录',
				data: [],
			}
		} else {
			if (error?.response?.data?.message) {
				ElMessage.error(error.response.data.message);
			} else {
				ElMessage.error(error.message);
			}
			return error?.response?.data || error;
		}
		// return Promise.reject(error)
	}
)
export default service
